package es.subastia.data.repository

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.Query
import dev.gitlive.firebase.firestore.firestore
import es.subastia.data.mapper.toData
import es.subastia.data.mapper.toDomain
import es.subastia.data.model.AuctionDataModel
import es.subastia.domain.model.AuctionDomainModel
import es.subastia.domain.model.AuctionTypeDomainModel
import es.subastia.domain.model.ProvinceDomainModel
import es.subastia.domain.repository.AuctionsRepository
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class AuctionsRepositoryImpl : AuctionsRepository {

    private val firestore = Firebase.firestore

    override fun getAuctionById(auctionId: String): Flow<AuctionDomainModel?> {
        return firestore.collection("auctions").document(auctionId).snapshots.map { snapshot ->
            if (snapshot.exists) {
                try {
                    snapshot.data<AuctionDataModel>().toDomain()
                } catch (e: Exception) {
                     null
                }
            } else {
                null
            }
        }
    }

    override suspend fun getAuctions(type: AuctionTypeDomainModel?, procedureType: es.subastia.domain.model.AuctionProcedureType?, province: ProvinceDomainModel?, searchQuery: String?): List<AuctionDomainModel> {
        var query: Query = firestore.collection("auctions")

        if (province != null) {
            query = query.where { "province" equalTo province.toData().nm }
        }

        if (type != null) {
            query = query.where { "category" equalTo type.toData().text }
        }

        if (procedureType != null) {
            query = query.where { "type" equalTo procedureType.label }
        }

        if (!searchQuery.isNullOrBlank()) {
            val term = searchQuery.trim().lowercase().split(" ").firstOrNull()
            if (!term.isNullOrBlank()) {
                query = query.where { "keywords" contains term }
            }
        }

        try {
            val snapshot = query.get()
            return snapshot.documents.mapNotNull {
                try {
                    it.data<AuctionDataModel>().toDomain()
                } catch (e: Exception) {
                    null
                }
            }
        } catch (e: Exception) {
            return emptyList()
        }
    }
}
